<template>
    <section>
        <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
        />
        <Nodata v-if="!loading && retur_penjualan_groups.length == 0" />
        <div class="box" v-if="!loading && retur_penjualan_groups.length > 0">
            <div class="card">
                <div class="table-responsive">
                    <table
                        class="
                            table table-vcenter table-hover
                            card-table
                            table-striped
                        "
                    >
                        <thead>
                            <tr class="text-muted">
                                <th>Comp</th>
                                <th>No Group</th>
                                <th>Toko</th>
                                <th>Gudang</th>
                                <th>Total Invoice</th>
                                <th>Total Print</th>
                                <th>Grand Total</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(retur_penjualan, index) in retur_penjualan_groups" :key="index">
                                <td>
                                    <span class="badge bg-blue-lt mr-2">
                                    {{ retur_penjualan.kode_perusahaan }}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        class="link-primary cursor-pointer"
                                        @click="_detail(retur_penjualan.id_retur_penjualan_group)"
                                    >
                                        {{ retur_penjualan.id_retur_penjualan_group }}
                                    </span>
                                </td>
                                <td class="text-primary">
                                    {{ retur_penjualan.no_acc }}<br />
                                    {{ retur_penjualan.nama_toko }} 
                                </td>
                                <td>{{ retur_penjualan.nama_gudang }}</td> 

                                <td>{{ retur_penjualan.total_invoice }}</td>
                                <td>{{ retur_penjualan.print_count }}</td>
                                <td>
                                    <div>
                                        Rp {{ ribuan(Math.round(retur_penjualan.grand_total)) }}
                                    </div>
                                </td>
                                <td>
                                    <b-dropdown dropleft variant="link" size="lg" no-caret>
                                        <template slot="button-content">
                                            <i class="fe fe-more-vertical"></i>
                                        </template>
                                        <b-dropdown-item @click.native="_detail(retur_penjualan.id_retur_penjualan_group)">Rincian</b-dropdown-item>
                                    </b-dropdown>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <b-pagination
                v-if="retur_penjualan_groups.length > 0 && !loading"
                align="center"
                class="mt-5"
                :total-rows="paginate.totalRows"
                v-model="paginate.currentPage"
                :per-page="paginate.perPage"
                @change="_pageChange"
            />
        </div>
        <FormFilter
            :config.sync="filter.config"
            :initData="filter.data"
            :dismiss.sync="filter.dismiss"
            :isSubmit.sync="filter.isSubmit"
            @submit="filter.action"
        />
        <FormDetailGroup
            @fetchIndex="_get"
        />

    </section>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import FormDetailGroup from "./modals/details.vue"
import { mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "ReturPenjualanGroup",
    components: {
        FormFilter,
        FormDetailGroup
    },
    data(){
        return {
            loading: false,
            
            filter: {
                config: { view: false, title: null },
                data: null,
                isSubmit: false,
                action: () => {},
            },
            dataFilter: {
                id_perusahaan: "",
                keyword: "",
                depo: [],
            },
            paginate: {
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                fromPage: 0,
            },
        }
    },
    mixins: [helper],
    computed: {
        ...mapState("retur_penjualan_group", {
            retur_penjualan_groups: (state) => state.datas.group,
        }),
    },
    methods: {
        ...mapActions("retur_penjualan_group", ["getReturPenjualanGroup","showReturPenjualanGroup"]),
        ...mapMutations("retur_penjualan_group", [
            "SET_DETAIL_MODAL",
        ]),
        async _get(){
            this.loading = true;
            let formData = {
                id_perusahaan: this.dataFilter.id_perusahaan,
                per_page: this.paginate.perPage,
                page: this.paginate.currentPage,
                depo: this.dataFilter.depo,
                keyword: this.dataFilter.keyword,
            };
            try{
                const res = await this.getReturPenjualanGroup(formData)
                this.paginate.totalRows = res.total;
                this.loading = false;
            }catch(err){
                this.loading = false;
            }
        },
        async _detail(id) {
            try{
                await this.showReturPenjualanGroup(encodeURIComponent(id))
                this.SET_DETAIL_MODAL(true);
            }catch(err){
                console.log(err)
            }
        },
        _filter() {
            this.filter.config = { view: true, title: "Filter" };
            this.filter.action = (formData) => {
                for (const key in formData) {
                    this.dataFilter[key] = formData[key];
                }
                this._get()
            };
        },
        _search(keyword) {
            this.dataFilter.keyword = keyword;
            this._get();
        },

        _perPageChange(perPage){
            this.paginate.perPage = perPage;
            this._get()
        },
        _pageChange(page) {
            this.paginate.currentPage = page;
            this._get();
        },

    },
    mounted() {
        this._get();
    },

}

</script>
